import { createMiddleware, createStart } from "@tanstack/react-start";
import { withContentErrorStatus } from "#/_packages/umbrella/features/routing/utils/response-status";
import { requestErrorSerializationAdapter } from "#/_packages/umbrella/lib/orval/request-error";

const contentResponseMiddleware = createMiddleware().server(
	async ({ next, handlerType }) => {
		const result = await next();
		if (handlerType !== "router") return result;
		const { getResponseStatus, getResponseHeaders } = await import(
			"@tanstack/react-start/server"
		);
		return {
			...result,
			response: withContentErrorStatus(
				result.response,
				getResponseStatus(),
				getResponseHeaders(),
			),
		};
	},
);

export const startInstance = createStart(() => ({
	serializationAdapters: [requestErrorSerializationAdapter],
	requestMiddleware: [contentResponseMiddleware],
}));
